import React from "react";
import PropTypes from "prop-types";
import { List, ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
import Done from "@material-ui/icons/Done";
import Delete from "@material-ui/icons/Delete";
import Dropzone from "react-dropzone";
import { Row } from "react-flexbox-grid/lib/index";

const FilePickerStep = props => {
  const fileExtension = filename => filename.split(".").pop();
  const styles = {
    dropzone: {
      height: 300,
      borderStyle: "dashed",
      textAlign: "center",
      borderRadius: 5
    },
    dropzoneText: {
      height: "100%",
      fontSize: 28,
      color: "gray",
      fontFamily: "Roboto",
      marginTop: 15
    },
    active: {
      borderStyle: "solid"
    },
    filedrop: {}
  };
  const loadedFileNames = props.files.map(f => f.name);

  return (
    <Dropzone
      onDrop={files =>
        props.addFiles(
          files.filter(
            file =>
              !loadedFileNames.includes(file.name) &&
              fileExtension(file.name) === "xlsx"
          )
        )
      }
      accept=".xlsx"
      style={styles.dropzone}
      activeStyle={styles.active}
    >
      <Row center="xs" style={styles.dropzoneText}>
        <div style={{ width: "100%" }}>
          Drop excel files <small>(.xlsx)</small> or click here to open file
          browser.
          <div
            style={{
              marginLeft: "10px",
              marginRight: "10px",
              height: "80%",
              overflow: "auto"
            }}
          >
            <div>
              <List>
                {props.files.map((file, fileIndex) => (
                  <ListItem
                    button
                    onClick={e => {
                      e.stopPropagation();
                    }}
                    key={file.name}
                    style={{ wordWrap: "break-word" }}
                  >
                    <ListItemIcon>
                      {file.hasUploaded ? (
                        <Done />
                      ) : (
                        <Delete
                          onClick={e => {
                            e.stopPropagation();
                            props.removeFile(fileIndex);
                          }}
                        />
                      )}
                    </ListItemIcon>
                    <ListItemText primary={file.name} />
                  </ListItem>
                ))}
              </List>
            </div>
          </div>
        </div>
      </Row>
    </Dropzone>
  );
};

FilePickerStep.propTypes = {
  addFiles: PropTypes.func.isRequired,
  removeFile: PropTypes.func.isRequired,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      status: PropTypes.string,
      name: PropTypes.string.isRequired,
      message: PropTypes.string
    })
  )
};

FilePickerStep.defaultProps = {
  files: []
};

export default FilePickerStep;
